// Initial Setup of connection to API
import React from 'react';
import axios from 'axios';

import ApiContext from 'app/context/ApiContext';

const api = axios.create();

export default function ApiProvider(props) {

    return (
        <ApiContext.Provider value={api}>
            {props.children}
        </ApiContext.Provider>
    )
}
